<script>
  import { onMount } from 'svelte';
  import { Navigation, Pagination } from 'swiper';
  import viewport from '@/js/utils/useViewportAction.js';
  import SwiperNav from '$lib/swiper/Nav.svelte';
  import SwiperPagination from '$lib/swiper/Pagination.svelte';
  import SolutionsItem from './Item.svelte';

  export let solutions;
  let solutionSwiperEl, paginationEl, navPrevEl, navNextEl;
  let grow = false;

  onMount(() => {
    Object.assign(solutionSwiperEl, {
      modules: [Navigation, Pagination],
      navigation: {
        nextEl: navNextEl,
        prevEl: navPrevEl,
      },
      pagination: {
        el: paginationEl,
        clickable: true,
      },
      spaceBetween: 34,
      slidesPerView: 1.3,
      breakpoints: {
        1300: {
          slidesPerView: 3,
        },
        900: {
          slidesPerView: 2.5,
        },
        500: {
          slidesPerView: 1.5,
        },
      },
    });

    solutionSwiperEl.initialize();
  });
</script>

<div class="solutions-slider-wrapper">
  <section
    class="solutions-slider container container--medium section-border-top"
    class:grow
    use:viewport
    on:enterViewport={() => (grow = true)}
  >
    <h3 class="solutions-slider__title">{solutions.title}</h3>
    <p class="solutions-slider__desc">{solutions.desc}</p>
    <SwiperNav bind:prev={navPrevEl} bind:next={navNextEl} />
    <swiper-container bind:this={solutionSwiperEl} init={false}>
      {#each solutions.items as item}
        <swiper-slide>
          <SolutionsItem {item} />
        </swiper-slide>
      {/each}
    </swiper-container>
    <SwiperPagination bind:element={paginationEl} />
  </section>
</div>

<style lang="scss">
  @keyframes fade-up {
    0% {
      opacity: 0;
      transform: translateY(30px);
    }

    75% {
      opacity: 0.5;
    }

    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .solutions-slider-wrapper {
    overflow-x: hidden;
  }

  .solutions-slider {
    margin: 0 auto 10rem;
    position: relative;
    padding: 10rem 13.6rem 0;

    &.grow {
      animation: fade-up 1s ease-in-out backwards;
    }

    @include resp-max('m') {
      padding-right: 0;
      padding-left: 0;
    }

    @include resp-max('s') {
      margin-bottom: 5rem;
      padding-top: 5rem;
      border-top: unset;
    }

    &__title {
      text-align: center;

      @include resp-max('xs') {
        @include h2;
      }
    }

    &__desc {
      text-align: center;
      margin-top: 1.8rem;
      margin-bottom: 5rem;
      color: var(--royal-light);
    }
  }

  :global .solutions-slider .swiper-horizontal {
    @include resp-max('s') {
      overflow: visible;
    }
  }
</style>
